export default __webpack_public_path__ + "static/ambient-ai-dark-d7e0b339c140b1a94a03f9de0831410e.png";